/**
 * Which history action a keydown asks for: 'undo', 'redo' or null.
 *
 * Undo is Cmd/Ctrl-Z. Redo is Cmd/Ctrl-Shift-Z, and also Cmd-Y / Ctrl-Y (Josh, 10 Oct
 * 2026: Ctrl-Y is the Windows convention and many Mac apps accept Cmd-Y too). Cmd-Shift-Y
 * is left alone. The caller still skips text inputs, where undo/redo is the browser's.
 *
 * @param {{ code?: string, ctrlKey?: boolean, metaKey?: boolean, shiftKey?: boolean }|null} e
 * @returns {'undo'|'redo'|null}
 */
export function undoRedoShortcut(e) {
    if (!e || !(e.ctrlKey || e.metaKey)) return null;
    if (e.code === 'KeyZ') return e.shiftKey ? 'redo' : 'undo';
    if (e.code === 'KeyY' && !e.shiftKey) return 'redo';
    return null;
}

/**
 * True for Cmd-Y on a Mac while typing in a field. The field's own undo/redo is the
 * browser's, but Chrome on Mac maps Cmd-Y to its History page, not to redo, so the caller
 * prevents that and asks the field to redo instead (Josh's QA, 16 Oct). Ctrl-Y on Windows
 * already redoes in a field and is left alone.
 *
 * @param {{ code?: string, ctrlKey?: boolean, metaKey?: boolean, shiftKey?: boolean, altKey?: boolean }|null} e
 * @returns {boolean}
 */
export function isMacFieldRedo(e) {
    return !!e && e.code === 'KeyY' && !!e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
}


// WEBPACK FOOTER //
// ./src/lib/undo-redo-shortcut.js